import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router,Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Formulario_registro from './pages/Formulario_registro';
import Relacion_servicio from './pages/Relacion_servicio';
import Tabla_relacion from './pages/Formulario_editar';
import AdminPanel from './pages/AdminPanel';
import EditarUsuario from './pages/EditarUsuario';
import FormularioSubirReporte from './pages/Formulario_subirReporte';
import Login from './pages/Login';
import ProtectedRoute from './util/ProtectedRoute';
import ListaLogs from './pages/ListaLogs';
import Ayuda from './pages/Ayuda';
import AyudaAdmin from './pages/AyudaAdmin';
import Estadisticas from './pages/Estadisticas';
import { ConfigProvider } from './contexts/ConfigContext';

function App() {
  return (
    <ConfigProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login/>}/>
          <Route element={<ProtectedRoute/>}>
          <Route path='/Home' element={<Home/>}/>
            <Route path='/Registrar' element={<Formulario_registro/>}/>
            <Route path='/Relacion' element={<Relacion_servicio/>}/>
            <Route path='/RelacionSubirReporte' element={<FormularioSubirReporte/>}/>
            <Route path='/estadisticas' element={<Estadisticas/>}/>

            <Route path='/editar' element={<Tabla_relacion/>}/>
            <Route path='/login' element={<Login/>}/>
            <Route path='/logs' element={<ListaLogs/>}/>
            <Route path='/adminPanel' element={<AdminPanel/>}/>
            <Route path='/ayudaAdmin' element={<AyudaAdmin/>}/>
            <Route path='/ayuda' element={<Ayuda/>}/>
            <Route path='/adminPanel/editarUsuario/:id_usuario' element={<EditarUsuario/>}/>
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
